import { useTranslation } from 'react-i18next';

export default function Presentation() {
  const { t } = useTranslation();

  return (
    <section id="presentation" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('presentation.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('presentation.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold">{t('presentation.highlight.title')}</h3>
            <p className="text-lg text-gray-600 leading-relaxed">{t('presentation.highlight.description')}</p>
          </div>
          <div className="relative aspect-video rounded-lg overflow-hidden ">
            <img
              src="/images/dashboard3.png"
              alt="Dashboard"
              className="object-cover w-full h-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-20">
          <div className="relative aspect-video rounded-lg overflow-hidden  order-2 lg:order-1">
            <img
              src="/images/dashboard.png"
              alt="Dashboard"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="space-y-6 order-1 lg:order-2">
            <h3 className="text-3xl font-bold">{t('presentation.highlight2.title')}</h3>
            <p className="text-lg text-gray-600 leading-relaxed">{t('presentation.highlight2.description')}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-20">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold">{t('presentation.highlight3.title')}</h3>
            <p className="text-lg text-gray-600 leading-relaxed">{t('presentation.highlight3.description')}</p>
          </div>
          <div className="flex justify-center items-center">
            <div className="relative w-full rounded-lg overflow-hidden">
              <img
                src="/images/dashboard4.png"
                alt="Dashboard"
                className="object-contain w-full h-auto max-h-[400px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
